import comp from "./RightContainer";
export default comp;
